<script lang="ts">
  import { type Size, SIZE_MAP } from './icon';
  interface Props {
    size?: Size;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }
  let { size = $bindable('md'), ...rest }: Props = $props();
  let computedSize = $derived(SIZE_MAP[size] as Size);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={computedSize}
  height={computedSize}
  viewBox="0 0 24 24"
  {...rest}>
  <g>
    <path
      d="M13.959 7.043a1 1 0 1 1 1.414-1.414l5.667 5.667a.999.999 0 0 1-.031 1.445l-5.636 5.635a1 1 0 0 1-1.414-1.414l3.958-3.958H3.666a1 1 0 1 1 0-2H17.92l-3.961-3.961Z"
      fill="currentColor" />
  </g>
</svg>
